import { useDateFormatter } from './useDateFormatter';

export interface UseDateTimeTextFormatterArgs {
  showTime?: boolean;
  showWeekday?: boolean;
  isLocalTime?: boolean;
  timezone?: string;
  dateStyle?: 'short' | 'long';
  year?: '2-digit' | 'numeric';
  month?: '2-digit' | 'numeric' | 'long';
  day?: '2-digit' | 'numeric';
}

/** Preconfigured datformatter for datetime values */
export function useDateTimeTextFormatter({
  showTime = false,
  showWeekday = false,
  isLocalTime = false,
  timezone = 'UTC',
  dateStyle = 'short',
  year = 'numeric',
  month,
  day = '2-digit',
}: UseDateTimeTextFormatterArgs) {
  return useDateFormatter({
    year,
    month: month || dateStyle,
    day,
    weekday: showWeekday ? dateStyle : undefined,
    hour: showTime ? 'numeric' : undefined,
    minute: showTime ? 'numeric' : undefined,
    timeZoneName: showTime ? 'short' : undefined,
    timeZone: isLocalTime ? undefined : timezone,
  });
}
